export const categories = [
  {
    id: 'memory-foam',
    name: 'Memory Foam',
    path: '/products/memory-foam',
    description: 'Contours to your shape for personalized support',
    image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?w=600&q=80',
  },
  {
    id: 'down-feather',
    name: 'Down & Feather',
    path: '/products/down-feather',
    description: 'Luxuriously soft with cloud-like comfort',
    image: 'https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?w=600&q=80',
  },
  {
    id: 'cooling',
    name: 'Cooling Pillows',
    path: '/products/cooling',
    description: 'Temperature-regulating for hot sleepers',
    image: 'https://images.unsplash.com/photo-1631049421450-348ccd7f8949?w=600&q=80',
  },
  {
    id: 'orthopedic',
    name: 'Orthopedic',
    path: '/products/orthopedic',
    description: 'Ergonomic design for neck and spine support',
    image: 'https://images.unsplash.com/photo-1592789705501-f9ae4278a9c9?w=600&q=80',
  },
  {
    id: 'travel',
    name: 'Travel Pillows',
    path: '/products/travel',
    description: 'Portable comfort for journeys',
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80',
  },
  {
    id: 'body',
    name: 'Body Pillows',
    path: '/products/body',
    description: 'Full-length support for side sleepers',
    image: 'https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=600&q=80',
  },
];

export const products = [
  // Memory Foam
  {
    id: 'mf-premium-001',
    name: 'Premium Memory Foam Pillow',
    price: 2499,
    originalPrice: 3499,
    image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?w=600&q=80',
    rating: 4.8,
    reviewCount: 1256,
    badge: 'Best Seller',
    category: 'Memory Foam',
    categoryId: 'memory-foam',
    description: 'Our signature memory foam pillow with advanced pressure-relieving technology. Features a breathable cover and adjustable loft.',
    features: ['Adjustable Loft', 'Breathable Cover', 'Pressure Relief', 'Hypoallergenic'],
  },
  {
    id: 'mf-contour-002',
    name: 'Contour Memory Foam Pillow',
    price: 2999,
    image: 'https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=600&q=80',
    rating: 4.7,
    reviewCount: 843,
    badge: null,
    category: 'Memory Foam',
    categoryId: 'memory-foam',
    description: 'Ergonomically designed contour pillow that cradles your head and neck for optimal alignment.',
    features: ['Ergonomic Design', 'Neck Support', 'Medium Firm', 'Removable Cover'],
  },
  {
    id: 'mf-gel-003',
    name: 'Gel-Infused Memory Foam',
    price: 3299,
    originalPrice: 3999,
    image: 'https://images.unsplash.com/photo-1631049421450-348ccd7f8949?w=600&q=80',
    rating: 4.9,
    reviewCount: 567,
    badge: 'Sale',
    category: 'Memory Foam',
    categoryId: 'memory-foam',
    description: 'Cooling gel-infused memory foam for temperature regulation and ultimate comfort.',
    features: ['Gel Cooling', 'Temperature Neutral', 'High Density Foam', 'CertiPUR Certified'],
  },

  // Down & Feather
  {
    id: 'df-luxury-001',
    name: 'Luxury White Goose Down',
    price: 4999,
    image: 'https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?w=600&q=80',
    rating: 4.9,
    reviewCount: 432,
    badge: 'Premium',
    category: 'Down & Feather',
    categoryId: 'down-feather',
    description: 'Indulgent 800-fill power white goose down pillow with Egyptian cotton cover.',
    features: ['800 Fill Power', 'Egyptian Cotton', 'Soft Support', 'Responsibly Sourced'],
  },
  {
    id: 'df-blend-002',
    name: 'Down & Feather Blend',
    price: 2799,
    originalPrice: 3299,
    image: 'https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?w=600&q=80',
    rating: 4.6,
    reviewCount: 678,
    badge: 'Sale',
    category: 'Down & Feather',
    categoryId: 'down-feather',
    description: 'Perfect blend of 50% down and 50% feathers for balanced support and softness.',
    features: ['50/50 Blend', 'Medium Support', '100% Cotton Cover', 'Easy Care'],
  },
  {
    id: 'df-euro-003',
    name: 'European Down Pillow',
    price: 5499,
    image: 'https://images.unsplash.com/photo-1629140727571-9b5c6f6267b4?w=600&q=80',
    rating: 4.8,
    reviewCount: 234,
    badge: null,
    category: 'Down & Feather',
    categoryId: 'down-feather',
    description: 'Hotel-quality European white down pillow with double-stitched sateen cover.',
    features: ['European Down', 'Sateen Cover', 'Firm Support', 'Luxury Quality'],
  },

  // Cooling
  {
    id: 'cool-tech-001',
    name: 'CoolTech Pro Pillow',
    price: 3499,
    image: 'https://images.unsplash.com/photo-1631049421450-348ccd7f8949?w=600&q=80',
    rating: 4.7,
    reviewCount: 945,
    badge: 'Best Seller',
    category: 'Cooling',
    categoryId: 'cooling',
    description: 'Advanced phase-change material keeps you cool all night long.',
    features: ['Phase-Change Material', 'Always Cool', 'Moisture-Wicking', 'Anti-Microbial'],
  },
  {
    id: 'cool-bamboo-002',
    name: 'Bamboo Cooling Pillow',
    price: 2299,
    image: 'https://images.unsplash.com/photo-1592789705501-f9ae4278a9c9?w=600&q=80',
    rating: 4.5,
    reviewCount: 567,
    badge: null,
    category: 'Cooling',
    categoryId: 'cooling',
    description: 'Natural bamboo fiber cover with ventilated memory foam core.',
    features: ['Bamboo Cover', 'Ventilated Core', 'Eco-Friendly', 'Hypoallergenic'],
  },

  // Orthopedic
  {
    id: 'orth-cervical-001',
    name: 'Cervical Support Pillow',
    price: 3799,
    image: 'https://images.unsplash.com/photo-1592789705501-f9ae4278a9c9?w=600&q=80',
    rating: 4.8,
    reviewCount: 1123,
    badge: 'Doctor Recommended',
    category: 'Orthopedic',
    categoryId: 'orthopedic',
    description: 'Clinically designed cervical pillow for neck pain relief and proper alignment.',
    features: ['Cervical Support', 'Pain Relief', 'Adjustable Height', 'Medical Grade'],
  },
  {
    id: 'orth-wedge-002',
    name: 'Wedge Support Pillow',
    price: 2999,
    originalPrice: 3499,
    image: 'https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=600&q=80',
    rating: 4.6,
    reviewCount: 456,
    badge: 'Sale',
    category: 'Orthopedic',
    categoryId: 'orthopedic',
    description: 'Inclined wedge pillow for acid reflux, snoring, and respiratory issues.',
    features: ['Gradual Incline', 'Multi-Use', 'Firm Support', 'Removable Cover'],
  },

  // Travel
  {
    id: 'travel-compact-001',
    name: 'Compact Travel Pillow',
    price: 1299,
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80',
    rating: 4.5,
    reviewCount: 789,
    badge: null,
    category: 'Travel',
    categoryId: 'travel',
    description: 'Compressible memory foam travel pillow with carrying bag.',
    features: ['Compressible', 'Memory Foam', 'Carry Bag Included', 'Washable Cover'],
  },
  {
    id: 'travel-neck-002',
    name: 'Ergonomic Neck Travel Pillow',
    price: 1799,
    originalPrice: 2199,
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80',
    rating: 4.7,
    reviewCount: 543,
    badge: 'Sale',
    category: 'Travel',
    categoryId: 'travel',
    description: 'U-shaped ergonomic pillow with memory foam and snap closure.',
    features: ['U-Shaped Design', 'Snap Closure', 'Compact', 'Machine Washable'],
  },

  // Body Pillows
  {
    id: 'body-full-001',
    name: 'Full Body Support Pillow',
    price: 3999,
    image: 'https://images.unsplash.com/photo-1631049552057-403cdb8f0658?w=600&q=80',
    rating: 4.8,
    reviewCount: 876,
    badge: 'Best Seller',
    category: 'Body Pillow',
    categoryId: 'body',
    description: '54-inch full-length body pillow for total body support and comfort.',
    features: ['Full Length', 'Pregnancy Safe', 'Hypoallergenic Fill', 'Soft Cover'],
  },
  {
    id: 'body-pregnancy-002',
    name: 'Pregnancy Support Pillow',
    price: 4499,
    image: 'https://images.unsplash.com/photo-1631049421450-348ccd7f8949?w=600&q=80',
    rating: 4.9,
    reviewCount: 654,
    badge: 'Maternity',
    category: 'Body Pillow',
    categoryId: 'body',
    description: 'C-shaped pregnancy pillow designed for expecting mothers.',
    features: ['C-Shaped', 'Belly Support', 'Back Support', 'Detachable Sections'],
  },
];

export const getProductsByCategory = (categoryId) => {
  if (!categoryId) return products;
  return products.filter((product) => product.categoryId === categoryId);
};

export const getProductById = (id) => {
  return products.find((product) => product.id === id);
};

export const getFeaturedProducts = () => {
  return products.filter((product) => product.badge === 'Best Seller');
};

export const getSaleProducts = () => {
  return products.filter((product) => product.originalPrice);
};
